var _excluded = ["children", "disabled", "fieldSize", "htmlFor", "readOnly", "required"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import styled, { css } from 'styled-components';
import { Sizes } from "../../../constants.js";
var getLabelSizeStyles = fieldSize => {
  if (fieldSize === Sizes.LARGE) return css(["font:var(--body-text-medium);font-weight:600;padding:0 var(--border-radius-x-small) var(--spacing-1);"]);
  if (fieldSize === Sizes.SMALL) return css(["font:var(--body-text-x-small);font-weight:600;padding:0 var(--border-radius-x-small) calc(var(--spacing-1) / 2);"]);
  return css(["font:var(--body-text-small);font-weight:600;padding:0 var(--border-radius-x-small) calc(var(--spacing-1) / 2);"]);
};
var StyledLabel = styled.label.withConfig({
  componentId: "CL__sc-1lj5nye-0"
})(["display:block;color:", ";cursor:", ";", ";"], _ref => {
  var {
    $disabled,
    $readOnly
  } = _ref;
  if ($disabled) return 'var(--field-label-color-disabled)';
  if ($readOnly) return 'var(--field-label-color-readonly)';
  return 'var(--field-text-color)';
}, _ref2 => {
  var {
    $disabled,
    $readOnly
  } = _ref2;
  return $readOnly || $disabled ? 'default' : 'pointer';
}, _ref3 => {
  var {
    fieldSize
  } = _ref3;
  return getLabelSizeStyles(fieldSize);
});
var StyledAbbr = styled.abbr.withConfig({
  componentId: "CL__sc-1lj5nye-1"
})(["color:var(--highlight-color);display:inline-block;padding-left:", ";text-decoration:none;"], _ref4 => {
  var {
    fieldSize
  } = _ref4;
  return fieldSize === 'large' ? 'var(--spacing-1)' : 'calc(var(--spacing-1) / 2)';
});
var FieldLabel = /*#__PURE__*/React.forwardRef((_ref5, ref) => {
  var {
      children,
      disabled = false,
      fieldSize = Sizes.MEDIUM,
      htmlFor,
      readOnly = false,
      required = false
    } = _ref5,
    props = _objectWithoutProperties(_ref5, _excluded);
  return /*#__PURE__*/React.createElement(StyledLabel, _extends({
    $disabled: disabled,
    fieldSize: fieldSize,
    htmlFor: htmlFor,
    ref: ref,
    $readOnly: readOnly
  }, props), /*#__PURE__*/React.createElement("span", null, children), !disabled && !readOnly && required && /*#__PURE__*/React.createElement(StyledAbbr, {
    "aria-label": "This field is required",
    fieldSize: fieldSize,
    title: "This field is required"
  }, "*"));
});
export default FieldLabel;